class PlayerBoughtHealingMessage {
	static protocol = {}

	constructor() {}
}

export default PlayerBoughtHealingMessage
